import React from "react";

export const Footer = () => {
    return (
        <div className="guest-footer">
            <a href=".#support" className="footer-link">Support</a>
            <a href=".#solutions" className="footer-link">Solutions</a>
        </div>
    );
};